// Explicit dependencies
import "$previews";
import "$md-labels"; // Adds $.fn.showdown()

import { consume } from "$json/lib/functional";

let $container;

const fix = ({ $container }) => {
  $container.find("li, p").showdown();
};

$(document).on("bb-p:previews-rendered", consume(fix, 1));
